import React, {useEffect} from 'react';
import Routing from "./routing";
import {BrowserRouter} from "react-router-dom";
import {getDips, getDrinks, getSidelines, getSweetSomeThings} from "./store/actions/Menu";
import {connect} from "react-redux";
import {getCustomerInformation,
        checkAppView,
        updatePlatform,
        getCustomerDetailWithId,
        getPreviousAddressesWithId} from "./store/actions/Customer";
import {getQuickPizzaOrdering, getPizzaOrdering} from "./store/actions/Ordering";
import {getDeals} from "./store/actions/Deals";
import {Loading} from "./uiComponents";
import {getHomeData} from "./store/actions/Home";

export const renderLoading = (loading) => {
    if (loading) {
        return <Loading />
    }
    return null
};

function App(props) {

    useEffect(function() {
        check()
        getData();
    }, []);

    function check() {
        let obj = {};
        let search = (window.location && window.location.search) ? window.location.search.substring(1) : '';
        if (search) {
            obj = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
        }
        const {customerId, appview, platform} = obj;
        if (appview) props.checkAppView(String(appview) !== 'true');
        if (customerId) {
            let formdata = new FormData();
            formdata.append("customerId", customerId);
            props.getCustomerDetailWithId(formdata)
            props.getPreviousAddressesWithId(formdata)
        }
        if(!props.platformForStore){
            props.updatePlatform(platform ? platform : 'web')
        }
    }

    function getData(){
        props.getCustomerInformation();
        props.getHomeData();
        props.getSidelines();
        props.getDrinks();
        props.getDips();
        props.getSweetSomeThings();
        props.getQuickPizzaOrdering();
        props.getPizzaOrdering();
        props.getDeals();
    };

    return (
        <div className="app">
            <BrowserRouter>
                {renderLoading(props.loading)}
                <Routing/>
                {props.textinformation && props.textinformation.closeorder ? <div className='closed-overlay'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <g>
                            <path d="m470.392 2.911c-19.788 0-408.849 0-428.784 0-22.943 0-41.608 18.665-41.608 41.608v60.467 13.511c0 21.492 11.92 40.244 29.49 50.018v47.676c-14.079 3.387-24.576 16.078-24.576 31.181v81.607c0 15.104 10.497 27.794 24.576 31.181v44.065c-14.079 3.387-24.576 16.078-24.576 31.181v41.607c0 17.687 14.389 32.076 32.076 32.076h438.02c17.687 0 32.076-14.389 32.076-32.076v-41.607c0-15.104-10.497-27.794-24.576-31.181v-44.065c14.079-3.387 24.576-16.078 24.576-31.181v-81.607c0-15.104-10.497-27.794-24.576-31.181v-47.676c17.57-9.773 29.49-28.525 29.49-50.017 0-34.781 0-41.821 0-73.978 0-22.944-18.666-41.609-41.608-41.609zm26.608 41.608v52.967h-84.4v-79.575h57.792c14.671 0 26.608 11.936 26.608 26.608zm-283.2 73.978v-6.011h84.4v6.011c0 16.725-9.78 31.208-23.921 38.033-27.76 13.369-60.479-6.838-60.479-38.033zm-57.2 42.2c-19.559 0-36.049-13.377-40.811-31.462-1.669-6.403-1.363-10.27-1.389-16.75h84.4c-.338 3.678 1.724 14.983-6.118 27.877-7.41 12.182-20.812 20.335-36.082 20.335zm198.8 0c-23.269 0-42.2-18.931-42.2-42.2 0-.103 0-6.114 0-6.012h84.4v6.011c0 23.186-18.873 42.201-42.2 42.201zm42.2-63.211h-84.4v-79.575h84.4zm-99.4 0h-84.4v-79.575h84.4zm-99.4 0h-84.4v-79.575h84.4zm-183.8-52.967c0-14.672 11.936-26.608 26.608-26.608h57.792v79.575h-84.4zm0 73.978v-6.011h84.4c-.543 2.729 2.496 16.879-8.497 31.374-11.893 15.764-32.78 21.056-50.527 13.329-14.919-6.513-25.376-21.401-25.376-38.692zm477.086 316.909v41.607c0 9.416-7.66 17.076-17.076 17.076h-438.02c-9.416 0-17.076-7.66-17.076-17.076v-41.607c0-9.416 7.66-17.076 17.076-17.076h318.045c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-310.545v-42.276h423.02v42.276h-82.475c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h89.975c9.416 0 17.076 7.66 17.076 17.076zm-24.576-261.13v41.02h-282.797c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h290.297c9.416 0 17.076 7.66 17.076 17.076v81.607c0 9.416-7.66 17.076-17.076 17.076h-438.02c-9.416 0-17.076-7.66-17.076-17.076v-81.607c0-9.416 7.66-17.076 17.076-17.076h117.723c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-110.223v-41.02c24.449 5.533 49.819-5.462 62.41-27.485 22.125 38.731 77.569 38.217 99.4 0 22.201 38.806 77.592 38.171 99.4 0 22.118 38.666 77.533 38.274 99.4 0 12.681 22.18 38.095 33.014 62.41 27.485zm29.49-55.779c0 17.289-10.454 32.175-25.37 38.688-27.885 12.16-59.03-8.433-59.03-38.688 0-.103 0-6.114 0-6.012h84.4z"/>
                            <path d="m161.07 313.183c-5.281.03-10.951.051-15.264.055v-57.627c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v65.072c0 3.654 2.633 6.775 6.234 7.393 1.684.289 20.73.126 24.114.107 4.142-.023 7.481-3.399 7.458-7.542s-3.438-7.463-7.542-7.458z"/>
                            <path d="m353.523 328.239h27.191c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-19.691v-17.266h17.687c4.142 0 7.5-3.358 7.5-7.5 0-4.143-3.358-7.5-7.5-7.5h-17.687v-17.267h19.691c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-27.191c-4.142 0-7.5 3.358-7.5 7.5v64.533c0 4.142 3.358 7.5 7.5 7.5z"/>
                            <path d="m418.006 328.239c1.988 0 14.163-.066 18.426-.14 18.755-.328 32.368-16.713 32.368-38.96 0-23.387-13.271-39.1-33.022-39.1h-17.9c-4.021 0-7.5 3.215-7.5 7.563 0 66.55-.091 62.432.153 63.624.26 3.996 3.564 7.013 7.475 7.013zm17.771-63.201c13.288 0 18.022 12.449 18.022 24.1 0 16.34-8.854 23.809-17.629 23.962-2.448.043-6.836.077-10.69.101-.078-24.019-.035-16.231-.089-48.163z"/>
                            <path d="m108.599 305.801c-3.174-2.663-7.904-2.249-10.566.925-11.886 14.163-39.833 4.131-39.833-18.551 0-20.178 22.645-31.887 39.072-20.787 3.433 2.318 8.095 1.416 10.414-2.017 2.319-3.432 1.416-8.094-2.016-10.413-6.63-4.479-14.378-6.847-22.406-6.847-22.091 0-40.063 17.973-40.063 40.063 0 36.41 45.352 53.18 66.324 28.192 2.661-3.172 2.247-7.903-.926-10.565z"/>
                            <path d="m296.198 328.239c28.337 0 39.592-35.026 8.251-46.587-8.106-2.99-15.646-6.249-17.846-7.213-3.292-2.557-2.651-8.699 3.735-10.624 9.534-2.871 18.305 4.094 18.515 4.263 3.17 2.632 7.875 2.213 10.531-.945 2.665-3.171 2.255-7.902-.916-10.567-.604-.507-14.989-12.373-32.457-7.112-18.694 5.632-21.756 28.346-7.202 37.835 2.031 1.325 16.799 7.091 20.447 8.437 16.197 5.973 7.659 17.514-3.06 17.514-6.651 0-13.058-2.688-17.138-7.19-2.78-3.069-7.523-3.303-10.594-.521-3.069 2.781-3.302 7.524-.521 10.594 6.878 7.586 17.44 12.116 28.255 12.116z"/>
                            <path d="m217.179 328.239c22.091 0 40.064-17.972 40.064-40.064 0-22.091-17.973-40.063-40.064-40.063s-40.063 17.973-40.063 40.063c-.001 22.091 17.971 40.064 40.063 40.064zm0-65.128c13.82 0 25.064 11.244 25.064 25.063 0 13.82-11.244 25.064-25.064 25.064s-25.063-11.244-25.063-25.064c-.001-13.819 11.243-25.063 25.063-25.063z"/>
                        </g>
                    </svg>
                    <p>
                        {props.textinformation && props.textinformation.closeordertext}
                    </p>
                </div> : null}
            </BrowserRouter>
        </div>
    );
}
const mapStateToProps = ({ordering, deals, menu, home, customer}) => {
    let loading = ordering.loading || deals.loading || menu.loading || home.loading;
    return {
        loading,
        textinformation: (customer.textinformation) ? customer.textinformation : null,
        appView: customer.appView,
        platformForStore: customer.platform,
    }
};
const mapDispatchToProps = {
    getHomeData,
    getSidelines,
    getDrinks,
    getDips,
    getSweetSomeThings,
    getCustomerInformation,
    getQuickPizzaOrdering,
    getPizzaOrdering,
    getDeals,
    checkAppView,
    getCustomerDetailWithId,
    getPreviousAddressesWithId,
    updatePlatform
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
